import Model from './Model'

export default class Email extends Model {
    static async all(query = null) {
        const config = {params: {query}}
        const {data} = await Http.get(route('api.v1.emails.index'), config)
        return this.make(data)
    }

    getRecipientStrings(recipients) {
        return _.map(recipients, function (recip) {
            if (recip.name && recip.email && recip.name !== recip.email) {
                return recip.name + ' <' + recip.email + '>'
            }

            return recip.email
        }).join(', ')
    }

    recipients() {
        return this.getRecipientStrings(this.to)
    }
    ccs() {
        return this.getRecipientStrings(this.cc)
    }

}
